module.exports = __webpack_public_path__ + "media/images/icons/outlined/apple-def6b7c908e6fcd1f52c339062b2803e.svg";